import { render } from "./RowCategory.vue?vue&type=template&id=5b6410ca&scoped=true"
import script from "./RowCategory.vue?vue&type=script&lang=js"
export * from "./RowCategory.vue?vue&type=script&lang=js"

import "./RowCategory.vue?vue&type=style&index=0&id=5b6410ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6410ca"]])

export default __exports__